export class AcceptRejectDraft{
    templateReqRelId:number;
    comment:string;
    processTemplateReqRelId:number;
    processId :number;
    userMail:string;
    userId:number;
    templateTypeName:string;
    status:string;
    partyName:string;
    templateRequestedId:number;
    templateDataId:number;
    file:any;
}